import { render } from "./ApprovalsCounter.vue?vue&type=template&id=48749f3a&scoped=true"
import script from "./ApprovalsCounter.vue?vue&type=script&lang=js"
export * from "./ApprovalsCounter.vue?vue&type=script&lang=js"

import "./ApprovalsCounter.vue?vue&type=style&index=0&id=48749f3a&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48749f3a"]])

export default __exports__